import { Component, Input } from '@angular/core';
import { TableColumn } from '@schema/table.models';

@Component({
  selector: 'lgv-subsubtext-table-item',
  template: '{{getText()}}',
  standalone: false,
})
export class SubSubtextTableItemComponent {
  @Input() column: TableColumn;
  @Input() item: any;

  getText(): string {
    if (this.item[this.column.subsubprop]) {
      if (this.item[this.column.subsubprop][this.column.subprop]) {
        return this.item[this.column.subsubprop][this.column.subprop][this.column.prop] ?? '-';
      }
    }
    return '-';
  }
}
